// extracted by mini-css-extract-plugin
export default {"title":"title_title__97X12","mobile":"title_mobile__iEaGY"};